const currentViewByPanelId = new Map<string, string>()

export function setAssetViewCurrentView(panelId: string, view: string): void {
  currentViewByPanelId.set(panelId, view)
}

export function getAssetViewCurrentView(panelId: string): string | undefined {
  return currentViewByPanelId.get(panelId)
}

export function clearAssetViewCurrentView(panelId: string): void {
  currentViewByPanelId.delete(panelId)
}
